import { render, staticRenderFns } from "./PatientSidebar.vue?vue&type=template&id=bb6e0acc&scoped=true"
import script from "./PatientSidebar.vue?vue&type=script&lang=js"
export * from "./PatientSidebar.vue?vue&type=script&lang=js"
import style0 from "./PatientSidebar.vue?vue&type=style&index=0&id=bb6e0acc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e0acc",
  null
  
)

export default component.exports